import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HarvestCropComponent } from '../harvest-crop/harvest-crop.component';
import { HarvestUnitComponent } from '../harvest-unit/harvest-unit.component';

@Component({
  selector: 'app-add-harvest-crop',
  templateUrl: './add-harvest-crop.component.html',
  styleUrls: ['./add-harvest-crop.component.scss']
})
export class AddHarvestCropComponent implements OnInit {

  addHarvestForm: FormGroup;
  submitted = false;
  imageSrc: string | ArrayBuffer;
  uploadedImage: File;
  isSingleUploaded = false;
  cropDataList: any;
  unitDataList: any

  disable = false;
  response;

  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  today = new Date();
  currentD = this.datepipe.transform(this.today, 'dd/MM/yyyy');
  languages = [];
  languageList: any = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private datepipe: DatePipe,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.inItForm();
    this.getCropListData();
    this.getUnitDataList();
  }

  inItForm() {
    this.addHarvestForm = this.fb.group({
      cropId: ['', [Validators.required]],
      unitID: ['', [Validators.required]],
      date: [new Date()],
      image: new FormControl('', [Validators.required]),
    });
  }
  get attach_url() {
    return this.addHarvestForm.get('attachlink');
  }

  getCropListData() {
    this._userService.getHarvestCropList().subscribe((data: any) => {
      this.cropDataList = data.result.data
    });
  }

  getUnitDataList() {
    this._userService.getUnitList().subscribe((data: any) => {
      this.unitDataList = data.result.data
    });
  }

  manageUnit() {
    const dialogRef = this.dialog.open(HarvestUnitComponent, {
      width: '60%',
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getUnitDataList();
    });
  }

  manageCrop() {
    const dialogRef = this.dialog.open(HarvestCropComponent, {
      width: '60%',
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCropListData();
    });
  }

  onSubmit() {
    if (this.addHarvestForm.invalid) {
      this.toastr.warning("Please fill details")
      return false;
    } else {
      const formData: FormData = new FormData();
      formData.append('Image', this.addHarvestForm.value.image);
      formData.append('UnitId', this.addHarvestForm.value.unitID);
      formData.append('CropId', this.addHarvestForm.value.cropId);

      this._userService.addHarvest(formData).subscribe((data: any) => {
        // if (data['result'].data == 1) {
          this.toastr.success(data['result'].message);
          this.addHarvestForm.reset();
          this.imageSrc = ''
        // } else {
        //   this.toastr.error(data['result'].message, 'Error', {
        //     timeOut: 3000,
        //   });
        // }

      })
    }
  }

  listPage(): void {
    this.router.navigate(['/track-your-harvest']);
  }
  get f() {
    return this.addHarvestForm.controls;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  newsFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    let imageName = this.uploadedImage.name;
    let fileExtensionError: boolean;
    // check file type
    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG"];
    let fileExtension = imageName.split('.').pop();

    if (this.isInArray(allowedExtensions, fileExtension)) {
      fileExtensionError = false;
    } else {
      fileExtensionError = true;
    }
    // upload correct file
    if (fileExtensionError) {
      this.toastr.error("Upload correct file")
    } else {
      this.addHarvestForm.get('image')?.setValue(this.uploadedImage);
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);
        reader.readAsDataURL(file);
      }
      this.toastr.success("File added successfully")
    }
  }
  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
}
